import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'


export const getDriverDetail = createAsyncThunk('DriverStatusDashboard/getDriverDetail', async (GetDriver) => {
    
      const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriver', GetDriver, { mode: 'cors' })
    
      return response.data
    })
    export const GetDocumentDetailsByOwnerType = createAsyncThunk('appDriver/GetDocumentDetailsByOwner', async (Owner) => {

        const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentSummaryByOwnerTypeExpired', Owner, { mode: 'cors' })
        return response.data
      })
      export const RemoveDeviceToken = createAsyncThunk('RemoveDeviceToken/getBookings', async (params) => {
    
        const response = await axios.post('https://api.zasway.com:8443/UserLogin/UpdatUserDeviceTokenOnLogout', params, {mode:'cors'})
        
        return response.data
        
      })
 export const updateDriverStatus = createAsyncThunk('updatedriver/updatePersonalProfile ', async (params) => {
        
        const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateDriverStatus', params, { mode: 'cors' })
          
        return response.data
 })
 export const AddDriverShift = createAsyncThunk('updatedriver/updatePersonalProfile ', async (params) => {
        
    const response = await axios.post('https://api.zasway.com:8443/Driver/AddDriverShift', params, { mode: 'cors' })
      
    return response.data
})
export const updateBookingStatusOnRoute = createAsyncThunk('updatedriver/updateBookingStatusOnRoute ', async (params) => {
        
    const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })
      
    return response.data
})
export const getBookings = createAsyncThunk('UpcomingBooking/getBookings', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetDriverUpcomingBooking', params, {mode:'cors'})
     
    return response.data
})
export const GetDrNotifications = createAsyncThunk('UpcomingBooking/GetBookingEditNotif ', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Driver/GetDriverNotifications', params, { mode: 'cors' })
    
    return response.data
     
  })
  export const setIsNotified = createAsyncThunk('UpcomingBooking/GetBookingEditNotif ', async (params) => {
    
  const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateIsNotified', params, { mode: 'cors' })
  
  return response.data
  
  })
export const DriverStatusDashboardSlice = createSlice({
    name: 'DriverNavBar',
    initialState: {
        data: [],
        NotificationData: []
  
    },
    reducers: {},
    extraReducers: builder => {
        builder
           
            .addCase(getDriverDetail.fulfilled, (state, action) => {
                 
                state.data = action.payload.data
            })
            .addCase(GetDrNotifications.fulfilled, (state, action) => {
                
                state.NotificationData = action.payload
                
              })
              .addCase(getBookings.fulfilled, (state, action) => {
                  
                state.data = action.payload
            })

    }
})
export default DriverStatusDashboardSlice.reducer